import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useContractApi } from './contractApi';

export function ExistingPromoPanel({
  promotionalOrderId,
  visible = true,
  variant = 'floating',
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);
  const api = useContractApi();

  useEffect(() => {
    if (!promotionalOrderId) {
      setItems([]);
      setLoadFailed(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setLoadFailed(false);

    apiClient.get(`${api.promoOrders}/${promotionalOrderId}`)
      .then((res) => {
        if (cancelled) return;
        if (res.ok && Array.isArray(res.data?.data?.items)) {
          setItems(res.data.data.items.filter((item) => !item.is_cancelled));
        } else {
          setItems([]);
          setLoadFailed(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setLoadFailed(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [promotionalOrderId, api.promoOrders]);

  if (!visible || !promotionalOrderId) return null;

  const floating = variant !== 'inline';
  const containerStyle = floating
    ? {
        position: 'fixed',
        right: 'calc(50% + 296px)',
        bottom: '8vh',
        zIndex: 2001,
        width: 170,
      }
    : {
        width: '100%',
      };

  return (
    <div style={containerStyle} onClick={(e) => e.stopPropagation()}>
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: floating ? 12 : 10,
        boxShadow: floating ? '0 4px 16px rgba(0,0,0,0.12)' : 'none',
        overflow: 'hidden',
      }}>
        <div style={{
          padding: floating ? '8px 12px' : '7px 10px',
          fontSize: 11,
          fontWeight: 800,
          color: '#7c3aed',
          background: 'rgba(124,58,237,0.08)',
          borderBottom: '1px solid rgba(124,58,237,0.15)',
          letterSpacing: 0,
        }}>
          등록된 홍보물
        </div>

        <div style={{ padding: floating ? '8px 10px' : '8px 10px', display: 'grid', gap: 5 }}>
          {loading && (
            <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'center', padding: '8px 0' }}>
              불러오는 중...
            </div>
          )}
          {!loading && loadFailed && (
            <div style={{ fontSize: 11, color: '#dc2626', textAlign: 'center', padding: '8px 0' }}>
              홍보물 연결 확인 필요
            </div>
          )}
          {!loading && !loadFailed && items.length === 0 && (
            <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'center', padding: '8px 0' }}>
              등록된 홍보물 없음
            </div>
          )}
          {!loading && !loadFailed && items.map((item) => (
            <div key={item.id} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 6,
            }}>
              <span style={{
                fontSize: 12,
                color: 'var(--text-sub)',
                fontWeight: 500,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
              }}>
                {item.item_name}
              </span>
              <span style={{
                fontSize: 11,
                fontWeight: 700,
                color: '#7c3aed',
                background: 'rgba(124,58,237,0.10)',
                borderRadius: 6,
                padding: '1px 7px',
                flexShrink: 0,
                whiteSpace: 'nowrap',
              }}>
                {item.quantity}개
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
